import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loading: false,
    user: null,
    access_token: null,
    refresh_token: null
  },
  mutations: {
    auth_request(state) {
      console.log('mutations.auth_request');
      state.loading = true;
    },
    auth_success(state, { user, access_token, refresh_token }) {
      console.log('mutations.auth_success');
      state = {
        ...state,
        user,
        loading: false,
        access_token,
        refresh_token
      }
    },
    auth_error(state) {
      console.log('mutations.auth_error');
      state.loading = false;
    },
    auth_logout(state) {
      console.log('mutations.auth_logout');
      state.loading = false;
      state = {
        ...state,
        user: null,
        access_token: null,
        refresh_token: null
      }
    }
  },
  actions: {

  }
})
